<template>
    <table class="text-center">
        <tr style="height: 48px; font-size: 15px" class="font-weight-bold">
            <td class="lv">{{lvNr}}</td>
            <td class="vereinNr">{{vereinNr}}</td>
            <td class="verein">{{team.teamName}}</td>
        </tr>
        <tr class="headerLabel font-italic grey lighten-3">
            <td class="lv">Lv Nr.</td>
            <td class="vereinNr">Vereinsnr.</td>
            <td class="verein">{{typeText.toUpperCase()}}VEREIN</td>
        </tr>
    </table>
</template>

<script>
    import SpielService from "../../../../services/data/spielService";
    export default {
        name: "spiel-bericht-print-header-team",
        props: ['spiel', 'type'],
        computed: {
            team(){
                return this.spiel[this.type];
            },
            lvNr(){
                return SpielService.getLvIdFromVereinsNrLong(this.team.vereinsNr);
            },
            vereinNr(){
                return SpielService.getVereinsNrFromVereinsNrLong(this.team.vereinsNr);
            },
            typeText() { return this.type==='heim' ? 'Heim' : 'Gast'}
        },
    }
</script>

<style scoped>
    table { width: 100%; border-spacing: 0;  border-top: solid 1px black;
            border-left: solid 1px black;}/*border-collapse: collapse;*/
    td { border-bottom: solid 1px black; border-right: solid 1px black }
    .headerLabel { font-size: 9px }
    .lv { width: 10%; }
    .vereinNr { width: 12%;}
    .verein { width: 78%;}
</style>